module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"success":"插入成功"},"en":{"success":"Success"},"fr":{"success":"Succès"},"de":{"success":"Erfolg"},"jp":{"success":"成功"},"es":{"success":"Éxito"},"pt":{"success":"Sucesso"},"it":{"success":"Successo"}}')
  delete Component.options._Ctor
}
